<template>
  <div>
    <a-card title="展示模板">
      <div slot="extra">
        <a-button type="primary" icon="plus" @click="openFormModal({})">新增模板</a-button>
      </div>
      <a-alert message="展示模板用于自定义「消费者扫码后」看到的落地页内容与展示项, 在生码批次中选择即可生效。" type="info"
        show-icon style="margin-bottom: 12px;" />
      <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading"
        :pagination="pagination" @change="tableChange">
        <div slot="is_default" slot-scope="value">
          <a-tag :color="value ? 'green' : ''">{{ value ? '默认' : '-' }}</a-tag>
        </div>
        <div slot="action" slot-scope="value, item">
          <a-button-group>
            <a-button icon="edit" size="small" @click="openFormModal(item)">编辑</a-button>
            <a-popconfirm title="确定删除吗" @confirm="destroy(item.id)">
              <a-button type="danger" icon="delete" size="small">删除</a-button>
            </a-popconfirm>
          </a-button-group>
        </div>
      </a-table>
    </a-card>
    <form-modal v-model="visible" :form="targetItem" @create="list" @update="list" />
  </div>
</template>

<script>
  import { traceTemplateList, traceTemplateDestroy } from '@/api/trace'

  export default {
    name: 'TraceTemplate',
    components: {
      FormModal: () => import('./FormModal.vue'),
    },
    data() {
      return {
        columns: [
          { title: '序号', dataIndex: 'index', customRender: (v, item, index) => index + 1, width: 60 },
          { title: '模板名称', dataIndex: 'name' },
          { title: '默认', dataIndex: 'is_default', scopedSlots: { customRender: 'is_default' } },
          { title: '备注', dataIndex: 'remark' },
          { title: '创建时间', dataIndex: 'create_time' },
          { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 180 },
        ],
        searchForm: { page: 1, page_size: 16 },
        pagination: { current: 1, total: 0, pageSize: 16 },
        loading: false,
        items: [],
        visible: false,
        targetItem: {},
      };
    },
    methods: {
      list() {
        this.loading = true;
        traceTemplateList(this.searchForm).then(data => {
          this.pagination.total = data.count;
          this.items = data.results;
        }).finally(() => {
          this.loading = false;
        });
      },
      openFormModal(item) {
        this.targetItem = { ...item };
        this.visible = true;
      },
      destroy(id) {
        traceTemplateDestroy({ id }).then(() => {
          this.$message.success('删除成功');
          this.list();
        });
      },
      tableChange(pagination) {
        this.searchForm.page = pagination.current;
        this.pagination.current = pagination.current;
        this.list();
      },
    },
    mounted() {
      this.list();
    },
  }
</script>
